import { useEffect, useState } from 'react';

// UI components & helpers
import Brand from '../components/splash/Brand';
import HelpFooter from '../components/HelpFooter';
import { to_euro } from '../utils/utils';

// hooks
import useFeed from '../hooks/useFeed';
import useProducts from '../hooks/useProducts';
import useSettings from '../hooks/useSettings';
import IngotEdit from '../components/IngotEdit';



export default function ProductsAdmin () {

  // hook data deconstruction.
  const { feed, error:fError } = useFeed();
  const { products, error:pError, loading:pLoad } = useProducts();
  const { settings, error:sError, loading:sLoad } = useSettings();

  // local states.
  const [ masterKind, setKind ] = useState( 'XAU' );
  const [ error, set_error ] = useState( null );

  const ingotTabs = () => {
    switch ( masterKind ) {

      default:
      case 'XAU':
        return ( generate_ingot_tabs( 'XAU' ) );

      case 'XAG':
        return ( generate_ingot_tabs( 'XAG' ) );
    }
  }

  const priceTag = () => {
    switch ( masterKind ) {

      default:
      case 'XAU':
      case 'XAUPAC':
        return ( <div className='edit-header--'>
          <div className=' price gold '>
            Oro fix: <span className='silver'>{ to_euro( feed.XAU ) }</span> </div>
          <div className=' price gold '>
            aggiornato: <span className='silver'>{ feed.XAU_updated }</span> </div>
          <label className='form-control'>override prezzo oro:</label>
          <input
            className = 'header-fill'
            type     = 'number'
            step     = '0.001'
            value    = { 0.0 }
            onChange = { e => console.log( e ) } />

          <button
            className = ''
            disabled  = { false }
            onClick   = { () => console.log('confermando...') }

          >conferma</button>
        </div> );

      case 'XAG':
      case 'XAGPAC':
        return ( <div className='edit-header--'>
          <div className=' price gold '>
            Argento fix: <span className='silver'>{ to_euro( feed.XAG ) }</span> </div>
          <div className=' price gold '>
            aggiornato: <span className='silver'>{ feed.XAG_updated }</span> </div>
          <label>override prezzo argento:</label>
          <input
            className = ''
            type     = 'number'
            step     = '0.001'
            value    = { 0.0 }
            onChange = { e => console.log( e ) } />

          <button
            className = ''
            disabled  = { false }
            onClick   = { () => console.log('confermando...') }

          >conferma</button>
        </div> );
    }
  }

  useEffect(() => {
    // handle feed errors.
    if ( fError.type || pError.type || sError.type ) {
      console.log( 'feed error', fError );
      console.log( 'products error', pError );
      console.log( 'settings error', sError );
      set_error( 'feed error', fError, pError, sError );
    }
  }, [ feed, fError, pError, sError ] );



  return (
    <div className='full with-help-footer'>
      <Brand
        variant = "lg"
        align = "left"
        showChevron = 'true' />

      { !error &&
        <div className='cbody--'>

          {/* DIRECT FEEDS */}
          <div>
            { priceTag() }
          </div>

          {/* KIND SWITCH */}
          <div className='button-group'>

            <button
              className = ' button gold-bg'
              onClick   = { () => setKind( 'XAU' ) } >
              Lingotti Oro </button>

            <button
              className = ' button silver-bg'
              onClick   = { () => setKind( 'XAG' ) } >
              Lingotti Argento </button>

          </div>

          <div className='divider'></div>

          {/* THE PRODUCTS */}
          <div className='tabs-- '>
            { ingotTabs() }
          </div>


        </div>
      }

      { error && <p>{ error }</p> }

        <HelpFooter
          href="mailto:support@gekogold.com"
          target="_self" />
    </div>
  )


  // FUNCTIONS 2026 :: WIP :::::

  function generate_ingot_tabs( kind )
  {
    let tabs = [];

    products.forEach(( p, i ) => {
      if ( p.kind === kind ) {
        tabs.push(
          < IngotEdit
            key        = { p.kind + i + '-edit' }
            data       = { p }
            feed       = { feed }
            masterKind = { masterKind }
            confine    = { false }
            _on_change = { ( fee ) => product_fee_update( fee, p.name ) }
          />
        );
      }
    });

    switch( kind ) {
      default:
        return tabs;

      case 'XAU':
      case 'XAG':
        return tabs.reverse();
    }

  }

  // 2026 :: WIP UPDATE FEE for product
  function product_fee_update ( fee, name ) {
    console.log( `updating product fee for ${name} ... target fee ${fee}` );
  }

  // 2026 :: WIP UPDATE FEE for element
  function master_fee_update ( fee ) {
    console.log( 'updating master fee' );
  }

  // 2026 :: WIP UPDATE OVERRIDE for element
  function master_override_update ( override ) {
    console.log( 'updating master override' );
  }

}
